import service from '@/services/migrateReviews';

export default {
  loadMigrations({ state, commit }) {
    service.getMigrations(state.migrations.pagination).then(res => {
      return commit('loadMigrationsSuccess', res);
    });
  },
  setPagination({ commit }, payload) {
    return commit('setPagination', payload);
  },
  deleteMigration({ commit, dispatch }, payload) {
    service.deleteMigration(payload.id).then(() => {
      commit('deleteMigration', payload);
      return dispatch('loadMigrations');
    });
  },
};
